import React, { useState, useCallback, useEffect, useRef } from 'react'
import CookingTips from './CookingTips.jsx'
import * as api from '../../services/api.js'
import CookingRecipes from './CookingRecipes.jsx'
import RecipeInspiration from './RecipeInspiration.jsx'
import CookingMealPlan from './CookingMealPlan.jsx'
import CookingShoppingList from './CookingShoppingList.jsx'
import SectionWelcome from '../../components/SectionWelcome.jsx'

const TABS = [
  { id: 'learn',    label: 'Learn' },
  { id: 'plan',     label: 'Plan' },
  { id: 'do',       label: 'Do' },
]

export default function Cooking() {
  const [tab, setTab] = useState(() => {
    const p = new URLSearchParams(window.location.search)
    const t = p.get('tab')
    return TABS.find(x => x.id === t) ? t : 'learn'
  })
  const [recipes, setRecipes] = useState([])
  const [notice, setNotice]   = useState('')
  const [preFill, setPreFill] = useState(null)
  const shoppingRef = useRef([])

  useEffect(() => {
    api.getCookingRecipes().then(d => setRecipes(d || []))
    api.getShoppingList().then(d => { shoppingRef.current = d || [] })
  }, [])

  function goTab(id) {
    setTab(id)
    history.replaceState(null, '', `?tab=${id}`)
  }

  const addToShoppingList = useCallback((ingredients) => {
    const toAdd = ingredients
      .filter(i => i.name && i.name.trim())
      .map(i => ({
        id: Date.now() + Math.random(),
        name: i.name.trim(),
        amount: i.amount || '',
        category: 'Other',
        done: false,
      }))
    if (!toAdd.length) return
    const next = [...shoppingRef.current, ...toAdd]
    shoppingRef.current = next
    api.saveShoppingList(next)
    setNotice(`${toAdd.length} item${toAdd.length > 1 ? 's' : ''} added to Shopping List`)
    setTimeout(() => setNotice(''), 3000)
  }, [])

  return (
    <div className="page active">
      <div className="page-inner">
        <div className="hero">
          <p className="hero-eyebrow">My Life</p>
          <h1>Cooking</h1>
          <hr className="hero-rule" />
          <SectionWelcome text="Good food is one of life's quiet pleasures. Your recipes, tips, and meal ideas — all in one place." />
        </div>

        <div className="cooking-tabs">
          {TABS.map(t => (
            <button
              key={t.id}
              className={`cooking-tab ${tab === t.id ? 'active' : ''}`}
              onClick={() => goTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {notice && (
          <div style={{
            background: 'var(--accent)',
            color: 'white',
            borderRadius: '10px',
            padding: '10px 16px',
            fontSize: '0.85rem',
            marginBottom: '1rem',
            animation: 'fadeIn 0.2s ease',
          }}>
            {notice}
          </div>
        )}

        {tab === 'learn'    && <CookingTips />}
        {tab === 'plan'     && (
          <>
            <CookingMealPlan recipes={recipes} onAddToShoppingList={addToShoppingList} />
            <CookingShoppingList />
          </>
        )}
        {tab === 'do' && (
          <>
            <CookingRecipes onAddToShoppingList={addToShoppingList} preFill={preFill} onPreFillConsumed={() => setPreFill(null)} />
            <div className="do-section-divider" />
            <RecipeInspiration onPreFill={recipe => setPreFill(recipe)} />
          </>
        )}
      </div>
    </div>
  )
}
